
import React from 'react'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import product_data from './a_Product_Data';
import category_data from './a_Category_Data';
import page_data from './a_Page_Data';

function View_SearchAutocom() {
  // note: the id field is mandatory
  const products = product_data.map((product) => ({
    //id: index,
    name: product[0], // Assuming the product name is at index 0 of each product_data array
    brand:product[2],
    image:true,
  }));

  const categories = category_data.map((category, index) => ({   
   name: category && category.length > 0 ? category[0] : "",    
    image: false,
    type: 'Category : ',
  }));
    
    const pages = page_data.map((page, index) => ({      
      name: page && page.length > 0 ? page[0] : "",        
      image: false,
      type: 'Page : ',
     }));

  const items = [...products, ...categories, ...pages,];

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    //console.log(string, results)
  }

  const handleOnHover = (result) => {
    // the item hovered
    //console.log(result)
  }

  const handleOnSelect = (item) => {
    // the item selected
    //console.log(item)
  }

  const handleOnFocus = () => {
    //console.log('Focused')
  }

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: 'block', textAlign: 'left' }}>
        {item.image==true && <img src="/img/product/img1_1.png" width="30" className='me-2'  /> }
        {item.type && item.type }
          {item.name}</span>
      </>
    )
  }

  return (
    <div >
       
        <div style={{ width: 300 }}>
          <ReactSearchAutocomplete
            items={items}
            onSearch={handleOnSearch}
            onHover={handleOnHover}
            onSelect={handleOnSelect}
            onFocus={handleOnFocus}
            autoFocus
            formatResult={formatResult}
          />
        </div>
    </div>
  )
}

export default View_SearchAutocom;